import Types from './../Types'
import service from '../services/User'
import getAction from '.'
import {showMessage} from './../../utils'

export const getUser = (data:any) => {
    return async (dispatch:any) => {

        try {
            dispatch(getAction(Types.GET_USER_LOADING))
            let res:any =  await service.getUser(data)
            if(Array.isArray(res)){
             res=res[0]
            }
            dispatch(getAction(Types.GET_USER_SUCCESS, res))
            return res; 
        } catch (e:any) {
            dispatch(getAction(Types.GET_USER_ERROR,e))
            showMessage(e?.error?.msg)
        }

    }
}


export const updateUser = (data:any) => {
    return async (dispatch:any,getState:Function) => {
        
        try {
            dispatch(getAction(Types.UPDATE_USER_LOADING))
            const res:any =  await service.updateUser(data)    
            dispatch(getAction(Types.UPDATE_USER_SUCCESS))
            showMessage(res?.message)   
            return  res;  
        } catch (e:any) {
            dispatch(getAction(Types.UPDATE_USER_ERROR,e))
            showMessage(e?.error?.msg)
        }

    }
}

export const clearUserMessage = (data:any) => {
    return   (dispatch:any) => {
        
        dispatch(getAction(Types.CLEAR_USER_MESSAGE))

    }
}